import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_VenInfos/LoadErpInventoryData',
    method: 'post',
    data
  });
}
